module.exports = __webpack_public_path__ + "img/icon-icn-user.15445eb1.svg";